import { useEffect, useState } from 'react';

import { useAppStore } from 'src/hooks/useAppStore';

import VerifyParentalOtp from '../parental-control/VerifyParentalOtp';
import ReferralSubscriptionNudge from '../referral/ReferralSubscriptionNudge';
import ToastMessage from '../toastMessage';

const GenericPopupWrap = () => {
  const [gcpErrorMessage, setGcpErrorMessage] = useState('');
  const [showParentalPopup, setShowParentalPopup] = useState(false);
  const {
    popups: {
      showReferralSubscriptionNudge = false,
      referralRedirectLink = '',
      referralSourceElement = ''
    },
    parentalData
  } = useAppStore();
  useEffect(() => {
    if (parentalData?.showParentalPinPageFlag) {
      setShowParentalPopup(parentalData?.showParentalPinPageFlag);
    } else {
      setShowParentalPopup(false);
    }
  }, [parentalData]);

  return (
    <>
      {showParentalPopup ? (
        <VerifyParentalOtp
          parentalFlag={parentalData?.showParentalPinPageFlag}
        />
      ) : null}
      {showReferralSubscriptionNudge ? (
        <ReferralSubscriptionNudge
          link={referralRedirectLink}
          element={referralSourceElement}
        />
      ) : null}
      {gcpErrorMessage && (
        <ToastMessage message={gcpErrorMessage} duration={5 * 60 * 1000} />
      )}
    </>
  );
};

export default GenericPopupWrap;
